import React, { useEffect, useState } from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import ExportIcon from '@material-ui/icons/Assessment';
import { excelExportFunction, ISheet } from '../../../../components/ExcelExportButton';

export interface IExportByGamesPlayedProps {
    list: any[];
}

const ExportByGamesPlayed: React.FC<IExportByGamesPlayedProps> = ({ list }) => {

    const [exportSheets, setExportSheets] = useState<ISheet[]>([]);

    useEffect(() => {

        if (!list) return;

        let sheets = [];

        sheets.push({
            sheetName: "Top Games Played",
            sheetColumns: [
                { title: "Name", name: "name" },
                { title: "Surname", name: "surname" },
                { title: "Email", name: "email" },
                { title: "General", name: "general" },
                { title: "Games Played", name: "gamesPlayed" },
            ],
            sheetData: list || []
        });

        setExportSheets(sheets);

    }, [list]);

    return (
        <IconButton onClick={() => excelExportFunction({sheets: exportSheets})}>
            <Tooltip title="Export" aria-label="Export">
                <ExportIcon />
            </Tooltip>
        </IconButton>
    );
}

export default ExportByGamesPlayed;